import React, { Component } from 'react';
import { Link } from 'react-router';
import './NotFound.css';

export default class NotFound extends Component {
  render() {
    return (
      <div className="error-page">
        <div className="column body-content">
          <h2>Not Found</h2>
          <p>This page was not found.</p>
          <Link to="/">Back to home</Link>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/NotFound.js
 **/